/**
 * SearchBar - Search and filter controls for the Overview page
 *
 * Contains search input, sort dropdown, refresh interval selector,
 * visualization toggle, and match grouping control.
 */
import MatchGroupingControl from '../../features/overview/components/MatchGroupingControl';

const refreshOptions = [
  { label: "1s", value: 1000 },
  { label: "3s", value: 3000 },
  { label: "10s", value: 10000 },
  { label: "30s", value: 30000 },
  { label: "Off", value: 0 },
];

function SearchBar({
  search,
  onSearch,
  sortOrder,
  onSort,
  refreshMs,
  onRefreshChange,
  hasActiveFilters,
  onClearFilters,
  hasTimeData,
  showTimeSlider,
  onToggleTimeSlider,
  matchGrouping,
  onMatchGroupingChange,
}) {
  return (
    <>
      <input
        className="search"
        placeholder="Search filename or id"
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        style={{ flex: 1 }}
      />

      {hasActiveFilters && (
        <button
          className="chip"
          onClick={onClearFilters}
          title="Clear active filters"
        >
          × Clear filters
        </button>
      )}

      <label className="refresh-label">
        Sort
        <select
          value={sortOrder}
          onChange={(e) => onSort(e.target.value)}
          className="refresh-select"
        >
          <option value="oldest">↑ Added oldest</option>
          <option value="newest">↓ Added newest</option>
          <option value="capture_oldest">↑ Captured oldest</option>
          <option value="capture_newest">↓ Captured newest</option>
          <option value="filename_asc">A→Z Filename</option>
          <option value="filename_desc">Z→A Filename</option>
        </select>
      </label>

      <label className="refresh-label">
        Refresh
        <select
          value={refreshMs}
          onChange={(e) => onRefreshChange(Number(e.target.value))}
          className="refresh-select"
        >
          {refreshOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>

      {hasTimeData && (
        <button
          className={`chip ${showTimeSlider ? "active" : ""}`}
          onClick={onToggleTimeSlider}
          title={showTimeSlider ? "Hide time filter" : "Show time filter"}
        >
Time
        </button>
      )}

      <MatchGroupingControl
        value={matchGrouping}
        onChange={onMatchGroupingChange}
      />
    </>
  );
}

export { refreshOptions };
export default SearchBar;
